import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './GuidebooksPage.css';

const API_BASE = process.env.REACT_APP_API_BASE;

function getToken() {
  return localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
}
function authHeaders() {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` };
}

// ── Icons ──────────────────────────────────────────────────────────────────────

function PlusIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>; }
function EditIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>; }
function CloseIcon()  { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>; }
function SearchIcon() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>; }
function BookIcon()   { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>; }
function CopyIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>; }
function TrashIcon()    { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>; }
function EyeIcon()      { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>; }
function DownloadIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>; }
function ExternalIcon() { return <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>; }
function MapPinIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>; }
function UploadIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>; }

// ── Helpers ────────────────────────────────────────────────────────────────────

function fmtDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-US', { year:'numeric', month:'short', day:'numeric' }); }
  catch { return iso; }
}

// ── Sub-components ─────────────────────────────────────────────────────────────

function Modal({ onClose, children, maxWidth = 680 }) {
  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [onClose]);
  return (
    <div className="gb-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="gb-modal" style={{ maxWidth }}>
        {children}
      </div>
    </div>
  );
}

function Toast({ msg, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3000); return () => clearTimeout(t); }, [onDone]);
  return <div className="gb-toast">{msg}</div>;
}

function PropertySelector({ allProps, selectedIds, onChange }) {
  const [search, setSearch] = useState('');
  const visible = search
    ? allProps.filter(p => p.property_address.toLowerCase().includes(search.toLowerCase()))
    : allProps;

  function toggle(id) {
    onChange(selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id]);
  }

  return (
    <div className="gb-prop-selector">
      <div className="gb-prop-search-wrap">
        <input
          className="gb-prop-search"
          placeholder="Filter properties…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className="gb-prop-list">
        {visible.length === 0 && <div className="gb-prop-empty">No properties found.</div>}
        {visible.map(p => (
          <label key={p.propId} className={`gb-prop-item${selectedIds.includes(p.propId) ? ' gb-prop-item--checked' : ''}`}>
            <input
              type="checkbox"
              checked={selectedIds.includes(p.propId)}
              onChange={() => toggle(p.propId)}
            />
            <span>{p.property_address}</span>
          </label>
        ))}
      </div>
      {selectedIds.length > 0 && (
        <div className="gb-prop-count">{selectedIds.length} selected</div>
      )}
    </div>
  );
}

function CardsEditor({ cards, onChange }) {
  function add() {
    if (cards.length >= 6) return;
    onChange([...cards, { label: '', icon: '💡', question: '' }]);
  }
  function update(i, key, val) {
    const next = [...cards];
    next[i] = { ...next[i], [key]: val };
    onChange(next);
  }
  function remove(i) {
    onChange(cards.filter((_, idx) => idx !== i));
  }

  return (
    <div className="gb-cards-editor">
      {cards.length === 0 && (
        <p className="gb-hint">No cards yet. Add shortcuts guests can tap in the chatbot (max 6).</p>
      )}
      {cards.map((card, i) => (
        <div key={i} className="gb-card-row">
          <input
            className="gb-input gb-card-icon"
            value={card.icon}
            onChange={e => update(i, 'icon', e.target.value)}
            maxLength={4}
            placeholder="💡"
            title="Icon (emoji)"
          />
          <input
            className="gb-input gb-card-label"
            value={card.label}
            onChange={e => update(i, 'label', e.target.value)}
            placeholder="Label (e.g. WiFi)"
          />
          <input
            className="gb-input gb-card-question"
            value={card.question}
            onChange={e => update(i, 'question', e.target.value)}
            placeholder="Question sent to chatbot"
          />
          <button className="gb-card-remove" onClick={() => remove(i)} title="Remove card">
            <TrashIcon />
          </button>
        </div>
      ))}
      {cards.length < 6 ? (
        <button className="gb-add-card-btn" onClick={add}>
          <PlusIcon /> Add Card
        </button>
      ) : (
        <p className="gb-hint">Maximum 6 cards reached.</p>
      )}
    </div>
  );
}

// ── Guidebook form (shared by add + edit) ──────────────────────────────────────

const EMPTY_FORM = {
  guidebook_title: '', guide_text: '', guide_original_url: '', chatbot_description: '',
  wifi_name: '', wifi_password: '', nearby_attractions: '', nearby_restaurants: '',
};

function GuidebookModal({ mode, initial, allProps, onClose, onSave }) {
  const isEdit = mode === 'edit';

  const [form,    setForm]    = useState(initial ? {
    guidebook_title:    initial.guidebook_title    || '',
    guide_text:         initial.guide_text         || '',
    guide_original_url: initial.guide_original_url || '',
    chatbot_description:initial.chatbot_description|| '',
    wifi_name:           initial.wifi_name           || '',
    wifi_password:       initial.wifi_password       || '',
    nearby_attractions:  initial.nearby_attractions  || '',
    nearby_restaurants:  initial.nearby_restaurants  || '',
  } : EMPTY_FORM);
  const [selectedProps, setSelectedProps] = useState(
    initial?.properties?.map(p => p.propId) || []
  );
  const [cards,   setCards]   = useState(
    initial?.cards?.map(c => ({ label: c.card_label, icon: c.card_icon, question: c.card_question })) ||
    (mode === 'add' ? [
      { label: 'WiFi',     icon: '📶', question: 'What is the WiFi name and password?' },
      { label: 'Location', icon: '📍', question: 'Where is the property located and how do I get there?' },
    ] : [])
  );
  const [tab,     setTab]     = useState('info');
  const [errors,  setErrors]  = useState({});
  const [apiErr,        setApiErr]        = useState('');
  const [flagSnippets,  setFlagSnippets]  = useState([]);
  const [flagSentences, setFlagSentences] = useState([]);
  const [busy,          setBusy]          = useState(false);
  const [copied,        setCopied]        = useState(false);
  const [uploadBusy,    setUploadBusy]    = useState(false);
  const [uploadedFile,  setUploadedFile]  = useState('');

  function set(key, val) {
    setForm(f => ({ ...f, [key]: val }));
    setErrors(e => ({ ...e, [key]: '' }));
    setApiErr('');
  }

  function validate() {
    const errs = {};
    if (!form.guidebook_title.trim()) errs.guidebook_title = 'Title is required.';
    if (!form.guide_text.trim())      errs.guide_text      = 'Guide content is required.';
    if (!form.guide_original_url.trim()) errs.guide_original_url = 'Original URL is required.';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }

  async function handleSave() {
    if (!validate()) { setTab('info'); return; }
    setBusy(true);
    setApiErr('');
    try {
      await onSave({
        form,
        selectedProps,
        cards: cards.filter(c => c.label.trim() && c.question.trim()),
      });
    } catch (e) {
      setApiErr(e.message || 'Something went wrong.');
      setFlagSnippets(e.snippets || []);
      setFlagSentences(e.sentences || []);
    } finally {
      setBusy(false);
    }
  }

  function copyUrl() {
    if (initial?.guide_chatbot_url) {
      navigator.clipboard.writeText(initial.guide_chatbot_url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  }

  async function handleFileUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadBusy(true);
    setApiErr('');
    setFlagSnippets([]);
    setFlagSentences([]);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch(`${API_BASE}/api/guidebooks/parse-file`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const d = data.detail;
        setApiErr((typeof d === 'object' ? d.message : d) || 'Failed to parse file.');
        if (typeof d === 'object') {
          setFlagSnippets(d.flagged_snippets || []);
          setFlagSentences(d.flagged_sentences || []);
        }
        return;
      }
      set('guide_text', data.text);
      setUploadedFile(file.name);
    } finally {
      setUploadBusy(false);
      e.target.value = '';
    }
  }

  function downloadAsMd() {
    const blob = new Blob([form.guide_text], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = (uploadedFile.replace(/\.[^.]+$/, '') || 'guidebook') + '.md';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  const TABS = [
    { id: 'info',   label: 'Basic Info' },
    { id: 'props',  label: `Properties${selectedProps.length ? ` (${selectedProps.length})` : ''}` },
    { id: 'cards',  label: `Cards${cards.length ? ` (${cards.length})` : ''}` },
  ];

  return (
    <Modal onClose={onClose} maxWidth={700}>
      <div className="gb-modal-head">
        <h3>{isEdit ? 'Edit Guidebook' : 'New Guidebook'}</h3>
        <button className="gb-modal-close" onClick={onClose}><CloseIcon /></button>
      </div>

      {/* Chatbot URL preview (edit only) */}
      {isEdit && initial?.guide_chatbot_url && (
        <div className="gb-url-bar">
          <span className="gb-url-label">Chatbot URL</span>
          <span className="gb-url-text">{initial.guide_chatbot_url}</span>
          <button className="gb-copy-btn" onClick={copyUrl} title="Copy URL">
            <CopyIcon /> {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      )}

      {/* Tabs */}
      <div className="gb-tabs">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`gb-tab${tab === t.id ? ' gb-tab--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="gb-modal-body">
        {apiErr && (
          <div className="gb-api-err">
            <div className="gb-api-err-msg">{apiErr}</div>
            {flagSnippets.length > 0 && (
              <div className="gb-flagged-section">
                <span className="gb-flagged-label">Flagged words / phrases</span>
                <div className="gb-flagged-words">
                  {flagSnippets.map((w, i) => (
                    <span key={i} className="gb-flagged-word">"{w}"</span>
                  ))}
                </div>
              </div>
            )}
            {flagSentences.length > 0 && (
              <div className="gb-flagged-section">
                <span className="gb-flagged-label">Flagged sentences</span>
                <div className="gb-flagged-sentences">
                  {flagSentences.map((s, i) => (
                    <div key={i} className="gb-flagged-sentence">"{s}"</div>
                  ))}
                </div>
                <span className="gb-flagged-hint">Remove or rewrite the above sentences before resubmitting.</span>
              </div>
            )}
          </div>
        )}

        {/* ── Info tab ── */}
        {tab === 'info' && (
          <>
            <div className="gb-field">
              <label className="gb-label">Title <span className="gb-req">*</span></label>
              <input className={`gb-input${errors.guidebook_title ? ' gb-input--err' : ''}`}
                value={form.guidebook_title} onChange={e => set('guidebook_title', e.target.value)}
                placeholder="e.g. Beach House Guide" />
              {errors.guidebook_title && <span className="gb-field-err">{errors.guidebook_title}</span>}
            </div>

            <div className="gb-field">
              <label className="gb-label">Chatbot Description</label>
              <input className="gb-input"
                value={form.chatbot_description} onChange={e => set('chatbot_description', e.target.value)}
                placeholder="Ask me anything about this guidebook!" />
              <p className="gb-hint">Shown at the top of the guest chatbot.</p>
            </div>

            <div className="gb-field">
              <label className="gb-label">Original Guide URL <span className="gb-req">*</span></label>
              <input className={`gb-input${errors.guide_original_url ? ' gb-input--err' : ''}`}
                value={form.guide_original_url} onChange={e => set('guide_original_url', e.target.value)}
                placeholder="https://example.com/house-guide" />
              {errors.guide_original_url && <span className="gb-field-err">{errors.guide_original_url}</span>}
            </div>

            <div className="gb-field">
              <label className="gb-label">Guide Content <span className="gb-req">*</span></label>
              <textarea className={`gb-textarea${errors.guide_text ? ' gb-input--err' : ''}`}
                rows={7} value={form.guide_text} onChange={e => set('guide_text', e.target.value)}
                placeholder="Paste the full guidebook content here. The AI uses this to answer guest questions." />
              {errors.guide_text && <span className="gb-field-err">{errors.guide_text}</span>}
              <div className="gb-or-divider"><span>or import from file</span></div>
              <div className="gb-upload-zone">
                <label className="gb-upload-label">
                  <input
                    type="file"
                    accept=".pdf,.docx,.md,.txt"
                    style={{ display: 'none' }}
                    onChange={handleFileUpload}
                    disabled={uploadBusy}
                  />
                  {uploadBusy
                    ? <><span className="gb-spinner" /> Parsing &amp; checking content…</>
                    : <><UploadIcon /> Upload PDF, DOCX, or MD</>}
                </label>
                {uploadedFile && (
                  <button className="gb-dl-md-btn" type="button" onClick={downloadAsMd}>
                    <DownloadIcon /> Download as MD
                  </button>
                )}
              </div>
              {uploadedFile && (
                <span className="gb-upload-hint">Imported from: <strong>{uploadedFile}</strong> — you can edit the content above before saving.</span>
              )}
            </div>

            <div className="gb-field-row-2">
              <div className="gb-field">
                <label className="gb-label">WiFi Name</label>
                <input className="gb-input"
                  value={form.wifi_name} onChange={e => set('wifi_name', e.target.value)}
                  placeholder="e.g. BeachHouse_5G" />
              </div>
              <div className="gb-field">
                <label className="gb-label">WiFi Password</label>
                <input className="gb-input"
                  value={form.wifi_password} onChange={e => set('wifi_password', e.target.value)}
                  placeholder="e.g. welcome2024" />
              </div>
            </div>

            <div className="gb-field">
              <label className="gb-label">Nearby Attractions</label>
              <textarea className="gb-textarea" rows={3}
                value={form.nearby_attractions} onChange={e => set('nearby_attractions', e.target.value)}
                placeholder="e.g. Sunset Beach (5 min walk), City Museum (10 min drive)" />
              <p className="gb-hint">Lets the chatbot answer "what's nearby?" questions directly.</p>
            </div>

            <div className="gb-field">
              <label className="gb-label">Nearby Restaurants</label>
              <textarea className="gb-textarea" rows={3}
                value={form.nearby_restaurants} onChange={e => set('nearby_restaurants', e.target.value)}
                placeholder="e.g. The Lighthouse Grill (3 min walk), Pasta Corner (8 min drive)" />
            </div>

            {/* QR code (edit only) */}
            {isEdit && initial?.qr_code_base64 && (
              <div className="gb-qr-wrap">
                <span className="gb-label">Current QR Code</span>
                <img src={`data:image/png;base64,${initial.qr_code_base64}`} alt="QR Code" className="gb-qr-img" />
                <p className="gb-hint">QR regenerates automatically when you save with a different title.</p>
              </div>
            )}
          </>
        )}

        {/* ── Properties tab ── */}
        {tab === 'props' && (
          <div className="gb-field">
            <label className="gb-label">Linked Properties</label>
            {allProps.length === 0
              ? <p className="gb-hint">No properties available. Create properties first.</p>
              : <PropertySelector allProps={allProps} selectedIds={selectedProps} onChange={setSelectedProps} />
            }
          </div>
        )}

        {/* ── Cards tab ── */}
        {tab === 'cards' && (
          <div className="gb-field">
            <label className="gb-label">Quick Action Cards</label>
            <CardsEditor cards={cards} onChange={setCards} />
          </div>
        )}

        <div className="gb-modal-foot">
          <button className="gb-btn gb-btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button className="gb-btn gb-btn-primary" onClick={handleSave} disabled={busy}>
            {busy && <span className="gb-spinner" />}
            {busy ? 'Saving…' : isEdit ? 'Save Changes' : 'Create Guidebook'}
          </button>
        </div>
      </div>
    </Modal>
  );
}

// ── View modal (read-only) ─────────────────────────────────────────────────────

function GuidebookViewModal({ g, onClose, onEdit }) {
  const [copied,   setCopied]   = useState(false);
  const [signBusy, setSignBusy] = useState(null); // 'pdf' | 'docx' | null
  const [signErr,  setSignErr]  = useState('');

  function copyUrl() {
    navigator.clipboard.writeText(g.guide_chatbot_url || '').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  async function downloadSign(format) {
    setSignBusy(format);
    setSignErr('');
    try {
      const res = await fetch(`${API_BASE}/api/guidebooks/${g.guideid}/sign.${format}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.detail || `Failed to generate ${format.toUpperCase()} sign.`);
      }
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `${g.guidebook_title.replace(/[^\w]/g, '_')}_sign.${format}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      setSignErr(e.message);
    } finally {
      setSignBusy(null);
    }
  }

  return (
    <Modal onClose={onClose} maxWidth={660}>
      <div className="gb-modal-head">
        <div className="gb-view-title">
          <span className="gb-view-title-icon"><BookIcon /></span>
          <h3>{g.guidebook_title}</h3>
        </div>
        <button className="gb-modal-close" onClick={onClose}><CloseIcon /></button>
      </div>

      <div className="gb-modal-body">

        {/* Chatbot URL */}
        <div className="gb-view-section">
          <div className="gb-view-label">Chatbot URL</div>
          <div className="gb-view-url-row">
            <span className="gb-url-text">{g.guide_chatbot_url || '—'}</span>
            <div style={{ display:'flex', gap:6 }}>
              {g.guide_chatbot_url && (
                <a href={g.guide_chatbot_url} target="_blank" rel="noreferrer" className="gb-view-link-btn" title="Open chatbot">
                  <ExternalIcon />
                </a>
              )}
              <button className="gb-copy-btn" onClick={copyUrl}>
                <CopyIcon /> {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="gb-view-row-2">
          <div className="gb-view-section">
            <div className="gb-view-label">Chatbot Description</div>
            <div className="gb-view-value">{g.chatbot_description || '—'}</div>
          </div>
          <div className="gb-view-section">
            <div className="gb-view-label">Original Guide URL</div>
            <div className="gb-view-value">
              {g.guide_original_url
                ? <a href={g.guide_original_url} target="_blank" rel="noreferrer" className="gb-view-ext-link">{g.guide_original_url} <ExternalIcon /></a>
                : '—'}
            </div>
          </div>
        </div>

        {/* Guide content */}
        <div className="gb-view-section">
          <div className="gb-view-label">Guide Content</div>
          <div className="gb-view-content-box">{g.guide_text || '—'}</div>
        </div>

        {/* WiFi + nearby info */}
        <div className="gb-view-row-2">
          <div className="gb-view-section">
            <div className="gb-view-label">WiFi</div>
            <div className="gb-view-value">
              {g.wifi_name || g.wifi_password
                ? <>{g.wifi_name || '—'} {g.wifi_password && <span className="gb-view-by">/ {g.wifi_password}</span>}</>
                : '—'}
            </div>
          </div>
          <div className="gb-view-section">
            <div className="gb-view-label">Nearby Attractions</div>
            <div className="gb-view-value">{g.nearby_attractions || '—'}</div>
          </div>
        </div>
        <div className="gb-view-row-2">
          <div className="gb-view-section">
            <div className="gb-view-label">Nearby Restaurants</div>
            <div className="gb-view-value">{g.nearby_restaurants || '—'}</div>
          </div>
        </div>

        {/* Mapped properties */}
        <div className="gb-view-row-2">
          <div className="gb-view-section">
            <div className="gb-view-label">Linked Properties ({g.properties?.length || 0})</div>
            {g.properties?.length > 0
              ? <ul className="gb-view-list">
                  {g.properties.map(p => <li key={p.propId}>{p.property_address}</li>)}
                </ul>
              : <div className="gb-view-empty">No properties linked.</div>}
          </div>

          {/* Cards */}
          <div className="gb-view-section">
            <div className="gb-view-label">Quick Action Cards ({g.cards?.length || 0})</div>
            {g.cards?.length > 0
              ? <div className="gb-view-cards">
                  {g.cards.map((c, i) => (
                    <div key={i} className="gb-view-card-pill">
                      <span>{c.card_icon}</span> {c.card_label}
                    </div>
                  ))}
                </div>
              : <div className="gb-view-empty">No cards.</div>}
          </div>
        </div>

        {/* Audit */}
        <div className="gb-view-row-2">
          <div className="gb-view-section">
            <div className="gb-view-label">Created</div>
            <div className="gb-view-value">{fmtDate(g.created_date)}{g.created_by && <span className="gb-view-by"> by {g.created_by}</span>}</div>
          </div>
          <div className="gb-view-section">
            <div className="gb-view-label">Last Updated</div>
            <div className="gb-view-value">{g.modified_date ? <>{fmtDate(g.modified_date)}{g.modified_by && <span className="gb-view-by"> by {g.modified_by}</span>}</> : '—'}</div>
          </div>
        </div>

        {/* ── QR + Sign ── */}
        <div className="gb-view-sign-section">
          <div className="gb-view-sign-left">
            <div className="gb-view-label">QR Code</div>
            {g.qr_code_base64
              ? <img src={`data:image/png;base64,${g.qr_code_base64}`} alt="QR Code" className="gb-view-qr" />
              : <div className="gb-view-empty">No QR code generated yet.</div>}
          </div>

          <div className="gb-view-sign-right">
            <div className="gb-view-label">Printable Sign</div>
            <p className="gb-hint" style={{ marginBottom: 12 }}>
              Generate a printable sign with this guidebook's QR code embedded in your sign template.
            </p>
            {signErr && <div className="gb-sign-err">{signErr}</div>}
            <div className="gb-sign-btns">
              <button
                className="gb-sign-btn gb-sign-btn-pdf"
                onClick={() => downloadSign('pdf')}
                disabled={signBusy !== null}
              >
                {signBusy === 'pdf' ? <span className="gb-spinner gb-spinner-dark" /> : <DownloadIcon />}
                {signBusy === 'pdf' ? 'Generating…' : 'Download PDF Sign'}
              </button>
              <button
                className="gb-sign-btn gb-sign-btn-docx"
                onClick={() => downloadSign('docx')}
                disabled={signBusy !== null}
              >
                {signBusy === 'docx' ? <span className="gb-spinner gb-spinner-dark" /> : <DownloadIcon />}
                {signBusy === 'docx' ? 'Generating…' : 'Download Word Sign'}
              </button>
            </div>
          </div>
        </div>

        <div className="gb-modal-foot">
          <button className="gb-btn gb-btn-ghost" onClick={onClose}>Close</button>
          <button className="gb-btn gb-btn-primary" onClick={onEdit}>
            <EditIcon /> Edit Guidebook
          </button>
        </div>
      </div>
    </Modal>
  );
}

// ── Property list modal ────────────────────────────────────────────────────────

function PropertyListModal({ guideid, guideTitle, onClose }) {
  const [props,   setProps]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [err,     setErr]     = useState('');

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [onClose]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/guidebooks/${guideid}`, { headers: authHeaders() });
        const body = await res.json();
        if (!res.ok) throw new Error(body.detail || 'Failed to load properties.');
        setProps(body.properties || []);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [guideid]);

  return (
    <Modal onClose={onClose} maxWidth={440}>
      <div className="gb-modal-head">
        <div>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#1A2744' }}>
            Linked Properties
          </h3>
          <p style={{ margin: '3px 0 0', fontSize: 12, color: '#8a9bb8' }}>{guideTitle}</p>
        </div>
        <button className="gb-modal-close" onClick={onClose}><CloseIcon /></button>
      </div>

      <div className="gb-modal-body">
        {err && <div className="gb-api-err">{err}</div>}

        {loading ? (
          <div className="gb-prop-list-loading">Loading…</div>
        ) : props.length === 0 ? (
          <div className="gb-view-empty">No properties linked to this guidebook.</div>
        ) : (
          <ul className="gb-prop-addr-list">
            {props.map(p => (
              <li key={p.propId} className="gb-prop-addr-item">
                <span className="gb-prop-addr-icon"><MapPinIcon /></span>
                <span className="gb-prop-addr-text">{p.property_address}</span>
              </li>
            ))}
          </ul>
        )}

        <div className="gb-modal-foot">
          <button className="gb-btn gb-btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </Modal>
  );
}

// ── Main page ──────────────────────────────────────────────────────────────────

export default function GuidebooksPage() {
  const [guidebooks, setGuidebooks] = useState([]);
  const [allProps,   setAllProps]   = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [fetchErr,   setFetchErr]   = useState('');
  const [propModal,  setPropModal]  = useState(null); // { guideid, title }
  const [search,     setSearch]     = useState('');
  const [modal,      setModal]      = useState(null); // null | { mode:'add'|'view'|'edit', data }
  const [detailLoad, setDetailLoad] = useState(false);
  const [toast,      setToast]      = useState('');

  const showToast = useCallback(msg => setToast(msg), []);

  const load = useCallback(async () => {
    setLoading(true);
    setFetchErr('');
    try {
      const [gbRes, prRes] = await Promise.all([
        fetch(`${API_BASE}/api/guidebooks`, { headers: authHeaders() }),
        fetch(`${API_BASE}/api/properties`,  { headers: authHeaders() }),
      ]);
      if (!gbRes.ok) {
        const d = await gbRes.json().catch(() => ({}));
        throw new Error(d.detail || 'Failed to load guidebooks.');
      }
      setGuidebooks(await gbRes.json());
      if (prRes.ok) setAllProps(await prRes.json());
    } catch (e) {
      setFetchErr(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return guidebooks;
    return guidebooks.filter(g =>
      g.guidebook_title?.toLowerCase().includes(q) ||
      g.guide_chatbot_url?.toLowerCase().includes(q)
    );
  }, [guidebooks, search]);

  async function openDetail(g, mode) {
    setDetailLoad(true);
    try {
      const res = await fetch(`${API_BASE}/api/guidebooks/${g.guideid}`, { headers: authHeaders() });
      const detail = await res.json();
      if (!res.ok) throw new Error(detail.detail || 'Failed to load guidebook.');
      setModal({ mode, data: detail });
    } catch (e) {
      showToast('Failed to load guidebook details.');
    } finally {
      setDetailLoad(false);
    }
  }

  const openView = (g) => openDetail(g, 'view');
  const openEdit = (g) => openDetail(g, 'edit');

  async function handleAdd({ form, selectedProps, cards }) {
    const res = await fetch(`${API_BASE}/api/guidebooks`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        guidebook_title:    form.guidebook_title,
        guide_text:         form.guide_text,
        guide_original_url: form.guide_original_url,
        chatbot_description:form.chatbot_description || 'Ask me anything about this guidebook!',
        property_ids: selectedProps,
        cards,
        wifi_name: form.wifi_name,
        wifi_password: form.wifi_password,
        nearby_attractions: form.nearby_attractions,
        nearby_restaurants: form.nearby_restaurants,
      }),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      const d = body.detail;
      const err = new Error((typeof d === 'object' ? d.message : d) || 'Failed to create guidebook.');
      if (typeof d === 'object') { err.snippets = d.flagged_snippets || []; err.sentences = d.flagged_sentences || []; err.categories = d.categories || []; }
      throw err;
    }
    setModal(null);
    showToast('Guidebook created successfully.');
    load();
  }

  async function handleEdit({ form, selectedProps, cards }) {
    const guideid = modal.data.guideid;

    const [gbRes] = await Promise.all([
      fetch(`${API_BASE}/api/guidebooks/${guideid}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({
          guidebook_title:    form.guidebook_title,
          guide_text:         form.guide_text,
          guide_original_url: form.guide_original_url,
          chatbot_description:form.chatbot_description || 'Ask me anything about this guidebook!',
          cards,
          wifi_name: form.wifi_name,
          wifi_password: form.wifi_password,
          nearby_attractions: form.nearby_attractions,
          nearby_restaurants: form.nearby_restaurants,
        }),
      }),
      fetch(`${API_BASE}/api/guidebooks/${guideid}/properties`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ property_ids: selectedProps }),
      }),
    ]);
    const gbBody = await gbRes.json().catch(() => ({}));
    if (!gbRes.ok) {
      const d = gbBody.detail;
      const err = new Error((typeof d === 'object' ? d.message : d) || 'Failed to update guidebook.');
      if (typeof d === 'object') { err.snippets = d.flagged_snippets || []; err.categories = d.categories || []; }
      throw err;
    }
    setModal(null);
    showToast('Guidebook updated successfully.');
    load();
  }

  return (
    <div className="gb-page">

      {/* ── Header ── */}
      <div className="gb-page-head">
        <div className="gb-summary">
          <span className="gb-chip">
            <BookIcon />
            <strong>{guidebooks.length}</strong>
            {' '}{guidebooks.length === 1 ? 'Guidebook' : 'Guidebooks'}
          </span>
        </div>
        <button className="gb-add-btn" onClick={() => setModal({ mode: 'add' })}>
          <PlusIcon /> New Guidebook
        </button>
      </div>

      {/* ── Search ── */}
      <div className="gb-search-bar">
        <span className="gb-search-icon"><SearchIcon /></span>
        <input
          className="gb-search-input"
          type="text"
          placeholder="Search by title or URL…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        {search && <button className="gb-search-clear" onClick={() => setSearch('')}><CloseIcon /></button>}
      </div>

      {fetchErr && <div className="gb-alert">{fetchErr}</div>}

      {/* ── Table ── */}
      <div className="gb-table-card">
        <div className="gb-table-wrap">
          {loading ? (
            <div className="gb-skeleton-rows">
              {[...Array(4)].map((_, i) => (
                <div className="gb-skeleton-row" key={i}>
                  <div className="gb-sk" style={{ width: '28%' }} />
                  <div className="gb-sk" style={{ width: '10%' }} />
                  <div className="gb-sk" style={{ width: '30%' }} />
                  <div className="gb-sk" style={{ width: '14%' }} />
                  <div className="gb-sk" style={{ width: '50px' }} />
                </div>
              ))}
            </div>
          ) : (
            <table className="gb-table">
              <thead>
                <tr>
                  <th>Guidebook Title</th>
                  <th>Properties</th>
                  <th>Chatbot URL</th>
                  <th>Created</th>
                  <th>Updated</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="gb-empty">
                      {search ? 'No guidebooks match your search.' : 'No guidebooks registered yet.'}
                    </td>
                  </tr>
                ) : filtered.map(g => (
                  <tr key={g.guideid}>
                    <td>
                      <button className="gb-title-btn" onClick={() => openView(g)} disabled={detailLoad}>
                        <span className="gb-book-icon"><BookIcon /></span>
                        <span className="gb-title-text">{g.guidebook_title}</span>
                      </button>
                    </td>
                    <td>
                      {g.property_count === 0 ? (
                        <span className="gb-prop-badge gb-prop-badge--none">0 properties</span>
                      ) : (
                        <button
                          className="gb-prop-badge gb-prop-badge--link"
                          onClick={() => setPropModal({ guideid: g.guideid, title: g.guidebook_title })}
                        >
                          {g.property_count} {g.property_count === 1 ? 'property' : 'properties'}
                        </button>
                      )}
                    </td>
                    <td className="gb-td-url">
                      {g.guide_chatbot_url
                        ? <a href={g.guide_chatbot_url} target="_blank" rel="noreferrer" className="gb-url-link">{g.guide_chatbot_url}</a>
                        : <span className="gb-unset">—</span>}
                    </td>
                    <td className="gb-td-date">
                      <div>{fmtDate(g.created_date)}</div>
                      {g.created_by && <div className="gb-td-by">{g.created_by}</div>}
                    </td>
                    <td className="gb-td-date">
                      <div>{fmtDate(g.modified_date)}</div>
                      {g.modified_by && <div className="gb-td-by">{g.modified_by}</div>}
                    </td>
                    <td>
                      <div className="gb-actions">
                        <button
                          className="gb-icon-btn gb-icon-view"
                          title="View details"
                          onClick={() => openView(g)}
                          disabled={detailLoad}
                        >
                          <EyeIcon />
                        </button>
                        <button
                          className="gb-icon-btn gb-icon-edit"
                          title="Edit guidebook"
                          onClick={() => openEdit(g)}
                          disabled={detailLoad}
                        >
                          <EditIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {!loading && filtered.length > 0 && (
          <div className="gb-table-foot">
            Showing {filtered.length} of {guidebooks.length} {guidebooks.length === 1 ? 'guidebook' : 'guidebooks'}
          </div>
        )}
      </div>

      {/* ── Modals ── */}
      {modal?.mode === 'view' && (
        <GuidebookViewModal
          g={modal.data}
          onClose={() => setModal(null)}
          onEdit={() => setModal({ mode: 'edit', data: modal.data })}
        />
      )}
      {modal?.mode === 'add' && (
        <GuidebookModal
          mode="add"
          initial={null}
          allProps={allProps}
          onClose={() => setModal(null)}
          onSave={handleAdd}
        />
      )}
      {modal?.mode === 'edit' && (
        <GuidebookModal
          mode="edit"
          initial={modal.data}
          allProps={allProps}
          onClose={() => setModal(null)}
          onSave={handleEdit}
        />
      )}

      {propModal && (
        <PropertyListModal
          guideid={propModal.guideid}
          guideTitle={propModal.title}
          onClose={() => setPropModal(null)}
        />
      )}

      {toast && <Toast msg={toast} onDone={() => setToast('')} />}
    </div>
  );
}
